export default "__VITE_ASSET__CZ1Srnco__"